module.exports = __webpack_public_path__ + "templates.product_variation_label_selector-6aa657d7.html";